export const MAX_RESULTS_PER_PAGE = 30;
